import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectInputTypeFilter } from 'shared/selectors/advancedFilters';
import { selectIsSeparatedInputType } from 'shared/selectors/jsonQuery';
import { EEntranceType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const InputTypeContainer: FC = () => {
  const { label, value, options } = useSelector(selectInputTypeFilter);
  const isSeparatedInputType = useSelector(selectIsSeparatedInputType);

  const onChange = useFilterChangeCallback();

  const handleInputTypeChange = useCallback(
    (newValue: NonEmptyArray<EEntranceType> | null) => {
      onChange({ action: 'setInputType', arguments: [newValue] });
    },
    [onChange],
  );

  const handleIsSeparatedInputTypeChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      onChange({ action: 'setIsSeparatedInputType', arguments: [checked ? true : null] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        <InlineFilter>
          <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleInputTypeChange} />
        </InlineFilter>
        <InlineFilter>
          <Checkbox label="Отдельный вход" checked={isSeparatedInputType} onChange={handleIsSeparatedInputTypeChange} />
        </InlineFilter>
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
